// @ts-ignore
import FacetBar from './FacetBar';

export default FacetBar;
